export class CurrencyData {
    private currencyList: string[] = [
        "EUR",
        "ILS",
        "USD",
        "CHF",
        "GBP",
        "CAD",
        "SGD",
        "ZAR"];

    public getCurrencyList():Array<string>
    {
        return this.currencyList;
    }
}